import React from 'react';

export const LegalNotice: React.FC = () => {
  return (
    <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">AVISO LEGAL Y DE USO</h2>

      <div className="prose prose-slate max-w-none">
        <p><strong>LisaServer.com</strong> ofrece servicios de alquiler de infraestructura de servidores y asistencia en la instalación de software de terceros, actuando siempre bajo petición expresa del cliente.</p>

        <p>El cliente es el único y exclusivo responsable de todo el contenido, datos, aplicaciones y ficheros que aloje, procese o transmita a través de los servidores contratados. Es obligación del cliente garantizar que posee todos los derechos de autor, licencias o permisos legales necesarios para la totalidad del material que gestiona en nuestros sistemas.</p>

        <p>Nuestra empresa proporciona la plataforma tecnológica, pero no supervisa, aprueba ni se hace responsable del uso que se le dé. <strong>LisaServer.com</strong> opera como un mero intermediario técnico y queda eximida de cualquier tipo de responsabilidad derivada del uso ilícito o no autorizado de contenido protegido por propiedad intelectual. Cualquier reclamación o disputa legal será responsabilidad íntegra del titular del contrato del servicio.</p>

        <hr className="my-6" />

        <p className="text-center text-sm text-gray-600">Se informa que LisaServer.com es una marca comercial y filial que opera bajo la entidad legal <strong>AthosFera, LLC.</strong></p>
      </div>
    </div>
  );
};
